/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment200,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReprocessPayment.ts";
import { reprocessPaymentResultViewModelSchema } from "../reprocessPaymentResultViewModelSchema.ts";

export const postApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidReprocessPayment200Schema =
  z.lazy(
    () => reprocessPaymentResultViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPayment200>;

/**
 * @description Parcela fora de aberto, sem Nosso Número, sem cartão de recorrência, método não suportado ou erro na cobrança
 */
export const postApiV1IndividualpaymentParcelsParcelidReprocessPayment400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidReprocessPayment401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1IndividualpaymentParcelsParcelidReprocessPayment404Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidReprocessPayment500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500>;

export const postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidReprocessPayment200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse>;
